import { Box, Typography, Grid2, Button } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";

const Apps = () => {
  const [apps, setApps] = useState([]);
  const navigate = useNavigate();
  const profile = JSON.parse(sessionStorage.getItem("profile"));
  const durables = JSON.parse(sessionStorage.getItem("durables"));
  const user = useSelector((state) => state.user.user);

  const handleSelectApps = (app) => {
    if (apps.includes(app)) {
      setApps(apps.filter((item) => item !== app));
    } else {
      setApps([...apps, app]);
    }
  };

  const handleRegister = async () => {
    try {
      if (
        !profile ||
        !profile.firstName ||
        !profile.lastName ||
        !profile.gender ||
        !profile.education ||
        !profile.occupation ||
        !profile.age ||
        !durables
      ) {
        console.log("Missing required fields. Redirecting to profile...");
        navigate("/profile");
        return;
      }

      if(apps.length === 0){
        alert("Select minimum one field from apps")
        return;
      }

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/demographic-data`,
        {
          username: user.username,
          firstName: profile.firstName,
          lastName: profile.lastName,
          gender: profile.gender,
          education: profile.education,
          occupation: profile.occupation,
          age: profile.age,
          city: profile.city,
          pincode: profile.pincode,
          location: profile.location,
          durables: durables,
          apps: apps,
        }
      );
      sessionStorage.removeItem("profile");
      sessionStorage.removeItem("durables");
      navigate("/dashboard");
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Box className='parent-div' sx={{display: {xs: 'block', sm: 'none !important'}}}>
      <div className="eclipse1"></div>
      <div className="eclipse2"></div>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "20px",
          zIndex: 100,
          position: "relative",
        }}
      >
        <Link to={"/register"}>
          <ArrowCircleLeftOutlinedIcon sx={{ color: "#fff" }} />
        </Link>
        <Typography className="heading" sx={{ marginLeft: "10px" }}>
          Create Profile
        </Typography>
      </Box>
      <form style={{ display: "flex", flexDirection: "column", flex: 1, height: '100%'}} className="main-container">
        <Box>
          <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
            Type of App I use Frequently
          </Typography>
          <Grid2 container rowSpacing={2} columnSpacing={2} my={2}>
            <Grid2 size={{ xs: 6 }}>
              <Box
                className={
                  apps.includes("OTT") ? "box-option-select" : "box-option"
                }
                onClick={() => handleSelectApps("OTT")}
              >
                OTT
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Box
                className={
                  apps.includes("Mobile_Banking")
                    ? "box-option-select"
                    : "box-option"
                }
                onClick={() => handleSelectApps("Mobile_Banking")}
              >
                Mobile Banking
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Box
                className={
                  apps.includes("Travel") ? "box-option-select" : "box-option"
                }
                onClick={() => handleSelectApps("Travel")}
              >
                Travel
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Box
                className={
                  apps.includes("Ticketing")
                    ? "box-option-select"
                    : "box-option"
                }
                onClick={() => handleSelectApps("Ticketing")}
              >
                Ticketing
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Box
                className={
                  apps.includes("Shopping") ? "box-option-select" : "box-option"
                }
                onClick={() => handleSelectApps("Shopping")}
              >
                Shopping
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Box
                className={
                  apps.includes("Social_Media")
                    ? "box-option-select"
                    : "box-option"
                }
                onClick={() => handleSelectApps("Social_Media")}
              >
                Social Media
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Box
                className={
                  apps.includes("Music") ? "box-option-select" : "box-option"
                }
                onClick={() => handleSelectApps("Music")}
              >
                Music
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Box
                className={
                  apps.includes("Food_Ordering")
                    ? "box-option-select"
                    : "box-option"
                }
                onClick={() => handleSelectApps("Food_Ordering")}
              >
                Food Ordering
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Box
                className={
                  apps.includes("Gaming") ? "box-option-select" : "box-option"
                }
                onClick={() => handleSelectApps("Gaming")}
              >
                Gaming
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Box
                className={
                  apps.includes("Trading") ? "box-option-select" : "box-option"
                }
                onClick={() => handleSelectApps("Trading")}
              >
                Share Trading
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Box
                className={
                  apps.includes("News") ? "box-option-select" : "box-option"
                }
                onClick={() => handleSelectApps("News")}
              >
                News
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Box
                className={
                  apps.includes("Payment") ? "box-option-select" : "box-option"
                }
                onClick={() => handleSelectApps("Payment")}
              >
                Payment
              </Box>
            </Grid2>
          </Grid2>
        </Box>

        <Button variant="contained" onClick={handleRegister}>
          Submit
        </Button>
      </form>
    </Box>
  );
};

export default Apps;
